var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F60D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDD67",
    d: "M62 31.999C62 48.568 48.568 62 32.002 62 15.434 62 2 48.568 2 31.999 2 15.432 15.434 2 32.002 2 48.568 2 62 15.432 62 31.999z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F46767",
    d: "M61.848 13.219c-.463-2.654-2.031-4.889-4.463-5.553-2.654-.727-5.082.316-7.438 2.703-1.32-3.631-3.338-6.326-6.52-7.709-3.259-1.421-6.427-.464-8.425 2.063-2.076 2.629-2.902 6.678-.68 11.975C36.404 21.657 45.734 31.709 46.004 32c.363-.227 10.754-6.721 13.299-9.908 2.49-3.121 3.006-6.228 2.545-8.873zM29.002 4.723c-1.996-2.527-5.166-3.484-8.426-2.063-3.184 1.383-5.201 4.078-6.523 7.709C11.697 7.983 9.27 6.94 6.615 7.667c-2.43.664-4 2.898-4.463 5.553-.459 2.645.057 5.752 2.545 8.873C7.244 25.28 17.637 31.774 18 32c.268-.291 9.6-10.344 11.682-15.303 2.222-5.296 1.396-9.345-.68-11.974z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M49 38.051c0-.803-.474-1.809-1.822-2.066-3.464-.662-8.582-1.344-15.179-1.344h-.001c-6.595 0-11.714.682-15.177 1.344-1.35.258-1.822 1.264-1.822 2.066 0 7.271 5.611 14.59 16.999 14.59h.001C43.388 52.641 49 45.322 49 38.051z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M44.69 38.283c-2.195-.367-6.838-1.012-12.69-1.012-5.854 0-10.496.645-12.691 1.012-1.294.219-1.373.744-1.283 1.486.054.443.137.975.265 1.553.142.641.262.936 1.266.816 1.921-.229 22.968-.229 24.888 0 1.004.119 1.123-.176 1.266-.816.127-.578.211-1.109.265-1.553.087-.742.008-1.267-1.286-1.486z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F60D);
export default __webpack_public_path__ + "static/media/1f60d.7a6cadb2fce0bec8008b65474abb7d7a.svg";
export { ForwardRef as ReactComponent };